import { render, staticRenderFns } from "./add-provider-v2.modal.vue?vue&type=template&id=79e95698&scoped=true"
import script from "./add-provider-v2.modal.vue?vue&type=script&lang=js"
export * from "./add-provider-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./add-provider-v2.modal.vue?vue&type=style&index=0&id=79e95698&prod&lang=scss&scoped=true"
import style1 from "./add-provider-v2.modal.vue?vue&type=style&index=1&id=79e95698&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e95698",
  null
  
)

export default component.exports